import React from 'react';

const Education = ({ institution, degree, time, location }) => {
  return (
    <div className="mb-4">
      <div className="bg-zinc-800/50 backdrop-blur-sm rounded-xl p-6 border border-zinc-700/50 hover:border-zinc-600 transition-all duration-300">
        <h3 className="text-xl font-bold text-white mb-1">{institution}</h3>
        <h4 className="text-base text-zinc-400 mb-2">{degree}</h4>
        <div className="flex flex-wrap gap-2 text-sm text-zinc-500">
          <span className="text-green-400 font-medium">{time}</span>
          {location && <span>• {location}</span>}
        </div>
      </div>
    </div>
  );
};

export default Education;
